import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
var config = {
  apiKey: 'AIzaSyDj7b6EjRkGBt83jHSbxoJgC0GCyN2JGq8',
  authDomain: 'form-register-f433e.firebaseapp.com',
  databaseURL: 'https://form-register-f433e.firebaseio.com',
  projectId: 'form-register-f433e',
  storageBucket: 'form-register-f433e.appspot.com',
  messagingSenderId: '937888484824'
}
let firebaseApp = firebase.initializeApp(config)

export default firebaseApp
